import Crud from '../views/FineType/Crud'
import Entity from '../views/FineType/Add'

let routes = {
    path: '/fine_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/fine_types/add',
            name: 'NewFineType',
            component: Entity,
            meta: {
                pageTitle: 'Types Of Fine',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/fine_types'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fine_types/edit/:id?',
            name: 'EditFineType',
            component: Entity,
            meta: {
                pageTitle: 'Types Of Fine',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/fine_types'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fine_types',
            name: 'list-fine_types',
            component: Crud,
            meta: {
                pageTitle: 'Types Of Fine',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
